import { type FC } from 'react';
import { ActiveBoundaryContainer } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/activeBoundary.container';
import { useBoundaryToolBTGsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/boundaryTool/boundaryToolBTGs.selectors';

type ActiveBoundariesComponentProps = {
  legendMode?: boolean;
};

export const ActiveBoundariesComponent: FC<ActiveBoundariesComponentProps> = ({ legendMode }) => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useBoundaryToolBTGsGroupedByBoundaryGroupSelector();

  return (
    <>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => (
          <ActiveBoundaryContainer
            key={boundaryGroupId}
            boundaryGroupId={boundaryGroupId}
            boundaryTerritoryGroups={boundaryTerritoryGroups}
            legendMode={legendMode}
          />
        ))}
    </>
  );
};
